import { getDateTimeString, getStartOfDay, isEarlier } from '@bondsports/date-time';

/**
 * Returns the timestamp to store for `lastTokenFetch` when the previous fetch
 * was on an earlier local calendar day. Returns null when today's fetch is
 * already recorded.
 */
export function nextLastTokenFetchValue(
	lastFetch: string | null,
	now: Date,
	timezone: string
): string | null {
	const startOfToday = getStartOfDay(now, true, timezone);

	if (!lastFetch || isEarlier(lastFetch, startOfToday)) {
		return getDateTimeString(now);
	}

	return null;
}
